import { createFileRoute } from '@tanstack/react-router';

import {
  parseListRouteSearch,
  type ListRouteSearch,
} from '../../hooks/use-list-table-helpers/index.js';
import { RouteGuard } from '../../lib/route-guard.js';
import { parsePickingTypesParam } from '../../modules/picking/parse-picking-types-param.js';
import { PickingListPage } from '../../modules/picking/picking-list-page.js';

/** `pick` opens that order's pick screen in a drawer over the list, e.g. "work-order/<id>", and `finish` opens it asking to Finish Pick; `tab=done` shows the Done tab, which `types` and `mine` narrow. */
type PickingListRouteSearch = ListRouteSearch & {
  pick?: string;
  finish?: true;
  tab?: 'done';
  types?: string;
  mine?: true;
};

export const Route = createFileRoute('/picking/')({
  validateSearch: (search: Record<string, unknown>): PickingListRouteSearch => ({
    ...parseListRouteSearch(search),
    ...(typeof search.pick === 'string' && { pick: search.pick }),
    ...(typeof search.pick === 'string' && search.finish === true && { finish: true as const }),
    ...(search.tab === 'done' && { tab: 'done' as const }),
    ...(parsePickingTypesParam(search.types).length > 0 && {
      types: parsePickingTypesParam(search.types).join(','),
    }),
    ...(search.mine === true && { mine: true as const }),
  }),
  component: () => (
    <RouteGuard route="/picking/">
      <PickingListPage />
    </RouteGuard>
  ),
});
